import PropTypes from 'prop-types';

const notificationConfigurationPropType = PropTypes.shape({
  trackOnLabel: PropTypes.bool,
  trackOnMailStream: PropTypes.bool,
  trackOnTimeStampString: PropTypes.string,
  trackTimeElapsed: PropTypes.number,
});

export default notificationConfigurationPropType;
